<template>
  <v-stepper v-model="stepSteeper" :items="['Infos Générales', 'Participants', 'Step 3']">
  <template v-slot:item.1>
    <v-card title="Infos Générales" flat>
        <v-text-field
            class="blue-textfield"
            color="blue"
            base-color="blue"
            v-model="nomProjet"
            label="Nom du projet"
            type="text"
            :prepend-icon="mdiBriefcase"
            variant="outlined"
            density="comfortable"
            required
        />
        <div class="d-flex align-center ">
            <v-icon class="mr-4 mb-5" color="blue">{{ mdiFormatListBulletedType }}</v-icon>
            <v-select
                v-model="selectedTypeId"
                :items="types"
                item-title="label"
                item-value="id"
                label="Type de projet"
                variant="outlined"
                density="comfortable"
                color="blue"
                base-color="blue"
                :menu-props="{ maxHeight: '250px' }"
                >
                <!-- Affichage personnalisé de chaque item dans la liste déroulante -->
                <template #item="{ props, item }">
                    <v-list-item v-bind="props">
                        <template #prepend>
                            <v-icon class="mr-2" color="blue">{{ item.raw.icon }}</v-icon>
                        </template>
                        <v-list-item-title color="blue"></v-list-item-title>
                    </v-list-item>
                </template>

                <!-- Affichage personnalisé de la sélection dans le champ -->
                <template #selection="{ item }">
                    <v-icon class="mr-2" color="blue">{{ item.raw.icon }}</v-icon>
                    <span>{{ item.raw.label }}</span>
                </template>
            </v-select>
        </div>
        <v-text-field
            class="blue-textfield"
            color="blue"
            base-color="blue"
            v-model="deadLine"
            label="Dead line"
            type="date"
            :prepend-icon="mdiCalendarAlertOutline"
            variant="outlined"
            density="comfortable"
            required
        />
        <div class="d-flex align-center ">
            <v-icon class="mr-4 mb-5" color="blue">{{ mdiFileTreeOutline }}</v-icon>
            <v-select
                v-model="selectedProjetParentId"
                :items="projetParents"
                item-title="ProjetNom"
                item-value="ProjetId"
                label="Projet parent"
                variant="outlined"
                density="comfortable"
                color="blue"
                base-color="blue"
                :menu-props="{ maxHeight: '250px' }"
                >
            </v-select>
        </div>
    </v-card>
  </template>

  <template v-slot:item.2>
    <v-card title="Participants" flat>
        <div>
        <v-checkbox
            v-for="utilisateur in utilisateurs"
            :key="utilisateur.id"
            v-model="utilisateursSelectionnes"
            :value="utilisateur.id"
            color="blue"
            base-color="blue"
            :disabled="utilisateur.uId === user?.id"  
        >
            <template #label>
            {{ utilisateur.Prenom }} {{ utilisateur.Nom }}
            <span style="opacity:0.7" class="font-italic ml-1"> ({{ utilisateur.Mail }})</span>
            </template>
        </v-checkbox>
        </div>
    </v-card>
  </template>

  <template v-slot:item.3>
    <v-card title="Step Three" flat>...</v-card>
  </template>
</v-stepper>
</template>

<script setup lang="ts">
import { Utilisateur, getMyFriends, getMainProjets, VueProjetUtilisateur, GetTypes, GetTypeFromNumber, type TypeItem } from '../supabase/client';
import { useUserSession } from '../composables/useUserSession';
import { computed, onMounted, ref, watch } from 'vue';
import { mdiCalendarAlertOutline, mdiBriefcase, mdiFormatListBulletedType, mdiFileTreeOutline} from '@mdi/js';

const { user } = useUserSession();
const stepSteeper = ref(1)

watch(stepSteeper, (newStep, oldStep) => {
  if (newStep > oldStep) {
    console.log(`Passage à l'étape ${newStep}`);
    console.log('nomProjet=', nomProjet.value);
    console.log('deadLine=', deadLine.value);
    console.log('selectedTypeId=', selectedTypeId.value);
    console.log('selectedProjetParentId=', selectedProjetParentId.value);
    console.log('utilisateursSelectionnes=', utilisateursSelectionnes.value);
    // Appelle ici ta fonction personnalisée
    if (oldStep === 1 && newStep === 2) {
      FinishStepper()
    }
  }
})

function FinishStepper() {
  console.log(" -- Début FinishStepper --");
  
  console.log(" -- Fin FinishStepper --");
}

//Données de la step 1
const nomProjet = ref('');
const deadLine= ref('');
const projetParents = ref<VueProjetUtilisateur[]>([])
const selectedProjetParentId = ref<number | null>(null)
const types = GetTypes()
const selectedTypeId = ref<number | null>(null)
const selectedType = computed<TypeItem | null>(() =>
  selectedTypeId.value != null ? GetTypeFromNumber(selectedTypeId.value) : null
)

//Données de la step 2
const utilisateurs = ref<Utilisateur[]>([])
const utilisateursSelectionnes = ref<number[]>([]);



const LoadMainProjets = async () => {
  console.log(" -- Début LoadMainProjets --");

  try {

    if (!user.value) {
      throw new Error('Utilisateur non authentifié');
    }

    console.log("Début getMainProjets");
    const result = await getMainProjets(user.value.id);
    console.log("Fin getMainProjets");

    console.log('result = ', result);
    projetParents.value = result;
  }catch(e){
    console.error('Erreur dans LoadMainProjets', e); 
  }

  console.log(" -- Fin LoadMainProjets --");
}

const LoadMyFriends = async () => {
  console.log(" -- Début LoadMyFriends --");

  try {

    if (!user.value) {
      throw new Error('Utilisateur non authentifié');
    }

    console.log("Début getMyFriends");
    const result = await getMyFriends(user.value.id);
    console.log("Fin getMyFriends");

    console.log('result = ', result);
    utilisateurs.value = result;

    // Sélection auto de l'utilisateur connecté
    const currentUser = utilisateurs.value.find(u => u.uId === user.value?.id); // ou par id numérique si c'est l'id
    if (currentUser && !utilisateursSelectionnes.value.includes(currentUser.id)) {
      utilisateursSelectionnes.value.push(currentUser.id);
    }

  }catch(e){
    console.error('Erreur dans LoadMyFriends', e); 
  }

  console.log(" -- Fin LoadMyFriends --");
}

onMounted(async () => {
  try
  {
    console.log("-- Début OnMounted --");

    if (!user.value) {
      throw new Error('Utilisateur non authentifié');
    }

    console.log("Début LoadMainProjets");
    await LoadMainProjets();
    console.log("Fin LoadMainProjets");

    
    console.log("Début LoadMyFriends");
    await LoadMyFriends();
    console.log("Fin LoadMyFriends");

    console.log("-- Fin OnMounted --");

  }catch(e){
    console.error(e);
  }
});
</script>